'use strict';

/* the following code is borrowed from the WebComponents project, licensed
 * under the BSD license. Source:
 * <https://github.com/webcomponents/webcomponentsjs/blob/5283db1459fa2323e5bfc8b9b5cc1753ed85e3d0/src/WebComponents/dom.js#L53-L78>
 */
// defaultPrevented is broken in IE.
// https://connect.microsoft.com/IE/feedback/details/790389/event-defaultprevented-returns-false-after-preventdefault-was-called
const workingDefaultPrevented = function () {
  const e = document.createEvent('Event');
  e.initEvent('foo', true, true);
  e.preventDefault();
  return e.defaultPrevented;
}();
if (!workingDefaultPrevented) {
  const origPreventDefault = window.Event.prototype.preventDefault;
  window.Event.prototype.preventDefault = function () {
    if (!this.cancelable) {
      return;
    }
    origPreventDefault.call(this);
    Object.defineProperty(this, 'defaultPrevented', {
      get: function () {
        return true;
      },
      configurable: true
    });
  };
}
/* end of borrowed code */

export function create_event(name) {
  let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$bubbles = _ref.bubbles,
    bubbles = _ref$bubbles === void 0 ? true : _ref$bubbles,
    _ref$cancelable = _ref.cancelable,
    cancelable = _ref$cancelable === void 0 ? false : _ref$cancelable;
  const event = document.createEvent('Event');
  event.initEvent(name, bubbles, cancelable);
  return event;
}
export default function (element, event) {
  let _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$bubbles = _ref2.bubbles,
    bubbles = _ref2$bubbles === void 0 ? true : _ref2$bubbles,
    _ref2$cancelable = _ref2.cancelable,
    cancelable = _ref2$cancelable === void 0 ? false : _ref2$cancelable;
  let payload = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  if (!(event instanceof window.Event)) {
    event = create_event(event, {
      bubbles,
      cancelable
    });
  }
  for (let key in payload) {
    if (payload.hasOwnProperty(key)) {
      event[key] = payload[key];
    }
  }
  element.dispatchEvent(event);
  return event;
}